// extracted by mini-css-extract-plugin
export var dropdownButton = "_36-0";
export var fullWidthDropdownButton = "_36-1";
export var icon = "_36-3";
export var iconPlaceholder = "_36-2";
export var shortcutContainer = "_36-4";